import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-800.css';
import '@fontsource/inter/latin-ext-400.css';
import '@fontsource/inter/latin-ext-500.css';
import '@fontsource/inter/latin-ext-600.css';
import '@fontsource/inter/latin-ext-800.css';
import '@fontsource/orbitron/latin-700.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorker } from './serviceWorkerRegistration';
import './utils/i18n';
import 'flag-icons/css/flag-icons.min.css';
import { setCachedDeferredInstallPrompt, type BeforeInstallPromptEventLike } from './utils/pwaInstallPrompt';

/** Capture install prompt as early as possible (may fire before React mounts). */
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e: Event) => {
    e.preventDefault();
    setCachedDeferredInstallPrompt(e as BeforeInstallPromptEventLike);
  });
}

registerServiceWorker();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Optional: pass a callback to reportWebVitals to send metrics to an analytics endpoint.
// See https://bit.ly/CRA-vitals
reportWebVitals();
